"use client";const r=(r,e)=>{if(""===r)throw new Error(e)};export{r as useCheckEmptyString};
